
      var _g, _g2, _path, _path2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLockUnlockNpLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 241,
  height: 240,
  viewBox: "0 0 241 240",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 54)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 108,
  width: 96,
  height: 60,
  rx: 6,
  transform: "rotate(-90 30 108)",
  stroke: "var(--theme-black, #000000)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 94,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(142 54)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 108,
  width: 96,
  height: 60,
  rx: 6,
  transform: "rotate(-90 30 108)",
  stroke: "var(--theme-black, #000000)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 94,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-grey-2, #716f73)",
  strokeWidth: 7,
  strokeLinecap: "round",
  d: "M108 122h28"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-grey-2, #716f73)",
  d: "m136 108 16 14-16 14z"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.85 0 0 .85 92 28)",
  strokeWidth: 3.4
}, /*#__PURE__*/React.createElement("rect", {
  x: 16.367,
  y: 33.7,
  width: 47.267,
  height: 33.933,
  rx: 3.633,
  stroke: "var(--theme-black, #000000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.525 32.667v-9.334c0-2.652 1.124-5.195 3.125-7.07 2-1.876 4.713-2.93 7.542-2.93 2.829 0 5.542 1.054 7.542 2.93 2 1.875 3.125 4.418 3.125 7.07v9.334",
  stroke: "var(--theme-black, #000000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.192 53.136v6.4M40.191 52.664a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width=\"241\" height=\"240\" viewBox=\"0 0 241 240\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g transform=\"translate(0, 54) scale(1)\">\r\n    <rect x=\"30\" y=\"108\" width=\"96\" height=\"60\" rx=\"6\" transform=\"rotate(-90 30 108)\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"60\" cy=\"94\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  </g>\r\n  <g transform=\"translate(142, 54) scale(1)\">\r\n    <rect x=\"30\" y=\"108\" width=\"96\" height=\"60\" rx=\"6\" transform=\"rotate(-90 30 108)\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"60\" cy=\"94\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  </g>\r\n  <line x1=\"108\" y1=\"122\" x2=\"136\" y2=\"122\" stroke=\"var(--theme-grey-2, #716f73)\" stroke-width=\"7\" stroke-linecap=\"round\"/>\r\n  <polygon points=\"136,108 152,122 136,136\" fill=\"var(--theme-grey-2, #716f73)\"/>\r\n  <g transform=\"translate(92, 28) scale(0.85)\">\r\n    <rect x=\"16.3667\" y=\"33.7\" width=\"47.2667\" height=\"33.9333\" rx=\"3.63333\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"3.4\"/>\r\n    <path d=\"M29.5254 32.6668V23.3335C29.5254 20.6813 30.6492 18.1378 32.6496 16.2624C34.65 14.3871 37.3631 13.3335 40.1921 13.3335C43.021 13.3335 45.7341 14.3871 47.7345 16.2624C49.7349 18.1378 50.8587 20.6813 50.8587 23.3335V32.6668\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"3.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M40.1917 53.1357V59.5367\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M40.1915 52.6645C43.137 52.6645 45.5248 50.2767 45.5248 47.3311C45.5248 44.3856 43.137 41.9978 40.1915 41.9978C37.246 41.9978 34.8582 44.3856 34.8582 47.3311C34.8582 50.2767 37.246 52.6645 40.1915 52.6645Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lock-unlock-np-locked.bfee2578004a7e8a0c6c642bc62b8080.svg"),
        {
          React: SvgLockUnlockNpLocked,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      